export enum ReportRoutesName {
  ReportIndex = "report-index",
}
